import type { PocDatepickerValueType, PocDateType } from 'commons/types';

export const toRangeValue = (from?: PocDateType, to?: PocDateType): PocDatepickerValueType => {
    if (!from && !to) {
        return null;
    }

    return [from ?? null, to ?? null].filter(Boolean);
};

export const fromRangeValue = (value: PocDatepickerValueType): { from?: PocDateType; to?: PocDateType } =>
    Array.isArray(value)
        ? { from: value[0] ?? undefined, to: value[1] ?? undefined }
        : { from: value ?? undefined, to: undefined };
